export default __webpack_public_path__ + "static/media/03.57d14020.webp";